import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask400To499Service {

  constructor() { }
}
